<template>
    <template v-if="user">
        <FriendsView :key="`friends-view-${user.userId}`" />
    </template>
    <template v-else-if="user === false">
        <PageLoadingError code="NO_USER" />
    </template>
</template>

<script>
import FriendsView from '@/app/pages/friends/FriendsView';
import { mapState } from 'vuex';
import PageLoadingError from '@/app/components/PageLoadingError';

export default {
    components: { PageLoadingError, FriendsView },

    computed: {
        ...mapState(['user']),
    },
};
</script>
